
import { Box } from "@chakra-ui/react";
import WaitingTimeTable from "../../tables/daily/WaitingTimeTable";
import EnterpriseReportSummary from "../../../reports/EnterpriseReportSummary";
import { buildDurationInsights } from "../../../../store/reportEnterpriseInsights";
import { formatTime } from "../../../../store/helpers";

const OrganizationWaitingTime = ({ reportIndex, data, renderConfig }) => {
  const insights = buildDurationInsights([data], {
    metric: "waiting",
    scopeLabel: "Organization",
    formatDuration: formatTime,
  });

  return (
    <Box>
      <EnterpriseReportSummary
        title="Daily Waiting Time Summary"
        kpis={insights.kpis}
        tables={insights.tables}
        notes={insights.notes}
      />
      <WaitingTimeTable
        table={[data]}
        chart={data.chart}
        reportIndex={reportIndex}
        renderConfig={renderConfig}
      />
    </Box>
  );
};

export default OrganizationWaitingTime;
